// Mock data for Unity Group website

export const companyInfo = {
  name: "Unity Group Services",
  tagline: "Your Complete Manpower Partner",
  description: "Multi-faceted service provider offering expert solutions in security, facility management, and housekeeping with unmatched professionalism and commitment to excellence.",
  videoUrl: "https://customer-assets.emergentagent.com/job_talent-agency-pro/artifacts/upjjktwf_Unity%20Secure%20Services.mp4",
  address: "1st Floor GC Grand Market Vaibhav Khand, Indirapuram, Ghaziabad, Uttar Pradesh 201014",
  phone: "+91-9599049564",
  alternatePhone: "+91-8383058393",
  email: "help.unityss@gmail.com",
  salesEmail: "sales@unityssllp.com",
  website: "https://unityssllp.com"
};

export const services = [
  {
    id: 1,
    division: "Unity Secure Services",
    shortName: "USS",
    icon: "Shield",
    description: "Comprehensive security solutions with trained professionals, advanced monitoring, and 24/7 vigilance.",
    image: "https://customer-assets.emergentagent.com/job_talent-agency-pro/artifacts/ehr0tl1c_6.JPG",
    offerings: [
      "Security Guards",
      "Gunman - PSO",
      "Security Officers",
      "Chief Security Officer"
    ],
    color: "from-slate-500 to-slate-700"
  },
  {
    id: 2,
    division: "Unity Facility Management Services",
    shortName: "UFMS",
    icon: "Settings",
    description: "Expert facility management ensuring smooth operations and maintenance of your premises.",
    image: "https://customer-assets.emergentagent.com/job_talent-agency-pro/artifacts/7nfco35l_9.JPG",
    offerings: [
      "Electrician - Plumber",
      "Welder - Carpenter",
      "Estate Manager",
      "Accountant - Help Desk - CCTV Operator"
    ],
    color: "from-green-600 to-green-800"
  },
  {
    id: 3,
    division: "Unity Housekeeping Services",
    shortName: "UHS",
    icon: "Sparkles",
    description: "Professional housekeeping services with advanced equipment and specialized cleaning solutions.",
    image: "https://customer-assets.emergentagent.com/job_talent-agency-pro/artifacts/wo6vorur_Screenshot%202026-03-25%20at%202.29.20%20PM.png",
    offerings: [
      "Housekeeping Cleaners",
      "HK Chemical Expert",
      "HK Supervisor",
      "Deep Cleaning Services"
    ],
    color: "from-blue-900 to-blue-950"
  }
];

export const usp = [
  {
    id: 1,
    icon: "Award",
    title: "Premium Supervisors",
    description: "Hiring supervisors who exceed market standards for smooth and efficient operations, ensuring tight manpower management.",
    gradient: "from-blue-700/10 to-blue-900/10"
  },
  {
    id: 2,
    icon: "Scale",
    title: "Legal Expertise",
    description: "Onboard legal support ensures seamless coordination with authorities and comprehensive understanding of local regulations.",
    gradient: "from-slate-700/10 to-slate-900/10"
  },
  {
    id: 3,
    icon: "MapPin",
    title: "Geo-Tagged Site Vigilance",
    description: "Head Office vigilance system with geo-tagged visits by field officers ensuring daily site attendance and protocol compliance verification.",
    gradient: "from-blue-700/10 to-blue-900/10"
  },
  {
    id: 4,
    icon: "Radio",
    title: "Walkie Talkie Support",
    description: "On-site walkie talkie communication system for instant coordination and rapid response to any security or operational needs.",
    gradient: "from-slate-700/10 to-slate-900/10"
  },
  {
    id: 5,
    icon: "Eye",
    title: "Real-Time Monitoring",
    description: "Head office constantly monitors on-site activities on an hourly basis for swift action and quality assurance.",
    gradient: "from-blue-700/10 to-blue-900/10"
  },
  {
    id: 6,
    icon: "Clock",
    title: "On-Time Payments",
    description: "Committed to paying employees before the 9th of each month and offering advances to keep the workforce motivated.",
    gradient: "from-slate-700/10 to-slate-900/10"
  }
];

export const technologies = [
  {
    id: 1,
    icon: "Satellite",
    title: "GPS Tracking",
    description: "Advanced GPS-enabled technology for sites covering 20+ acres with real-time location monitoring."
  },
  {
    id: 2,
    icon: "Video",
    title: "Body Cameras",
    description: "Security guards equipped with body cameras for enhanced safety and accountability."
  },
  {
    id: 3,
    icon: "QrCode",
    title: "QR Tagged PTR Rounds",
    description: "QR code-based patrol tracking rounds ensuring higher integration and accuracy in site monitoring."
  },
  {
    id: 4,
    icon: "Smartphone",
    title: "MyGate Integration",
    description: "App-based complaint resolution system for quick turnaround and efficient response management."
  }
];

export const clients = [
  { id: 1, name: "Palm Olympia" },
  { id: 2, name: "GAUR CITY" },
  { id: 3, name: "CBRE" },
  { id: 4, name: "Civitech" },
  { id: 5, name: "EXOTICA" },
  { id: 6, name: "Gulmohur Garden" },
  { id: 7, name: "PRUDENCE SCHOOL" }
];

export const gallery = [
  {
    id: 1,
    url: "https://customer-assets.emergentagent.com/job_talent-agency-pro/artifacts/ehr0tl1c_6.JPG",
    title: "Operations Team",
    category: "team"
  },
  {
    id: 2,
    url: "https://customer-assets.emergentagent.com/job_talent-agency-pro/artifacts/8jhiyh62_7.JPG",
    title: "USS Elite Security Guard",
    category: "security"
  },
  {
    id: 3,
    url: "https://customer-assets.emergentagent.com/job_talent-agency-pro/artifacts/op522dvc_5.JPG",
    title: "USS Security Guard",
    category: "security"
  },
  {
    id: 4,
    url: "https://customer-assets.emergentagent.com/job_talent-agency-pro/artifacts/7gmu1vb5_3.JPG",
    title: "USS Security Personnel",
    category: "security"
  },
  {
    id: 5,
    url: "https://customer-assets.emergentagent.com/job_talent-agency-pro/artifacts/3k2vyh8m_4.JPG",
    title: "USS Security Force",
    category: "security"
  },
  {
    id: 6,
    url: "https://customer-assets.emergentagent.com/job_talent-agency-pro/artifacts/7nfco35l_9.JPG",
    title: "UFMS Maintenance Team",
    category: "facility"
  },
  {
    id: 7,
    url: "https://customer-assets.emergentagent.com/job_talent-agency-pro/artifacts/tqfjym1y_10.JPG",
    title: "UFMS Facility Services",
    category: "facility"
  },
  {
    id: 8,
    url: "https://customer-assets.emergentagent.com/job_talent-agency-pro/artifacts/u2xydacw_11.JPG",
    title: "UFMS Maintenance Services",
    category: "facility"
  },
  {
    id: 9,
    url: "https://customer-assets.emergentagent.com/job_talent-agency-pro/artifacts/wo6vorur_Screenshot%202026-03-25%20at%202.29.20%20PM.png",
    title: "UHS Housekeeping Services",
    category: "housekeeping"
  }
];

export const stats = [
  { id: 1, value: "10+", label: "Years of Excellence" },
  { id: 2, value: "1000+", label: "Deployment" },
  { id: 3, value: "24/7", label: "Monitoring & Support" }
];
